import { TPaginationProps, TTableProps } from "../../types/types";
import SearchComponent from "../CoreComponents/Search";
import MainTable from "../MainTable/MainTable";
import Pagination from "../Pagination/Pagination";

type TProps<T = any> = {
  tableProps: TTableProps<T>,
  pagination?: TPaginationProps<T>,
  withSearch?: boolean,
  handleSearch?: (term: string) => void,
  noMargin?: boolean,
  onRowClick?: (row: any) => void
  renderChild?: () => JSX.Element;
};

function PaginatedTable({ tableProps, pagination = undefined, withSearch = false, handleSearch, noMargin = false, renderChild }: TProps) {

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, onRowClick, selectedRow } = tableProps;
  const { currentPage, totalPages, handleNextPage, handlePreviousPage } = pagination || {};

  return (
    <div className={noMargin ? '' : "mt-4"}>
      {withSearch &&
        <div className="flex justify-between items-center mb-4">
          <div className="flex-grow mr-4">
            <SearchComponent onSearch={handleSearch} />
          </div>
        </div>}
      <MainTable
        getTableProps={getTableProps}
        getTableBodyProps={getTableBodyProps}
        headerGroups={headerGroups}
        prepareRow={prepareRow}
        currentRows={pagination?.currentRows || rows}
        rows={rows}
        onRowClick={onRowClick}
        selectedRow={selectedRow}
      />
      {renderChild && renderChild()}
      {pagination && (
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          handleNextPage={handleNextPage}
          handlePreviousPage={handlePreviousPage}
        />
      )}
    </div>
  );
}

export default PaginatedTable;